import { getCart } from '@/utils/helper';

export default () => ({
  cart: getCart(),
});
